<template>
  <div>
    <p v-if="attachment.comment" class="lead pre-line">{{ attachment.comment }}</p>
    <Details v-if="attachment.object_type" :attachment="attachment" label="Related to"></Details>
  </div>
</template>

<script>
  import Details from './Details.vue';

  export default {
    components: {
      Details,
    },
    props: {
      attachment: {
        type: Object,
        default: function () {
          return {};
        }
      }
    }
  }
</script>